import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["year", "month", "day", "hiddenField"]
  static values = { initialDate: String }

  connect() {
    this.populateYears()
    this.populateMonths()
    this.populateDays()

    // 初期値の設定
    if (this.initialDateValue) {
      this.setInitialDate(this.initialDateValue)
    }

    this.updateHiddenField()
  }

  populateYears() {
    const currentYear = new Date().getFullYear()
    const startYear = 1920

    this.yearTarget.innerHTML = '<option value="">年</option>'
    for (let year = currentYear; year >= startYear; year--) {
      const option = document.createElement('option')
      option.value = year
      option.textContent = year
      this.yearTarget.appendChild(option)
    }
  }

  populateMonths() {
    this.monthTarget.innerHTML = '<option value="">月</option>'
    for (let month = 1; month <= 12; month++) {
      const option = document.createElement('option')
      option.value = month
      option.textContent = `${month}月`
      this.monthTarget.appendChild(option)
    }
  }

  populateDays() {
    this.dayTarget.innerHTML = '<option value="">日</option>'
    for (let day = 1; day <= 31; day++) {
      const option = document.createElement('option')
      option.value = day
      option.textContent = `${day}日`
      this.dayTarget.appendChild(option)
    }
  }

  updateHiddenField() {
    const year = this.yearTarget.value
    const month = this.monthTarget.value.padStart(2, '0')
    const day = this.dayTarget.value.padStart(2, '0')

    if (year && month && day) {
      this.hiddenFieldTarget.value = `${year}-${month}-${day}`
    } else {
      this.hiddenFieldTarget.value = ''
    }
  }

  setInitialDate(dateString) {
    if (!dateString) return

    const date = new Date(dateString)
    if (isNaN(date.getTime())) return

    this.yearTarget.value = date.getFullYear()
    this.monthTarget.value = date.getMonth() + 1
    this.dayTarget.value = date.getDate()
  }

  setInitialValues(year, month, day) {
    if (year) this.yearTarget.value = year
    if (month) this.monthTarget.value = month
    if (day) this.dayTarget.value = day
    this.updateHiddenField()
  }
}
